import React from "react";
import { ArrowRight, ArrowDown } from "lucide-react";
import { stats, images } from "../mock";

const Hero = () => {
  return (
    <section id="home" className="relative bg-black overflow-hidden">
      {/* Background image with overlay */}
      <div className="absolute inset-0">
        <img
          src={images.heroRhino}
          alt="Powerful rhino representing Claim Beast Public Adjusters fighting for Tampa Bay homeowners"
          className="w-full h-full object-cover object-center opacity-60"
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(90deg, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.6) 40%, rgba(0,0,0,0.2) 70%, rgba(0,0,0,0.4) 100%)",
          }}
        />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_30%,rgba(225,29,38,0.18),transparent_55%)]" />
      </div>

      {/* Red diagonal accent */}
      <div className="absolute top-0 right-1/3 h-full w-[2px] bg-[#E11D26]/70 rotate-12 origin-top hidden md:block" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-20 md:py-28 lg:py-32">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[2px] w-10 bg-[#E11D26]" />
            <span className="text-[#E11D26] text-xs sm:text-sm font-bold tracking-[0.25em] uppercase">
              FL &amp; GA Licensed Public Adjusters · Riverview, FL
            </span>
          </div>

          <h1
            className="font-black uppercase leading-[0.92] tracking-tight"
            style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
          >
            <span className="block text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
              Your Loss.
            </span>
            <span className="block text-[#E11D26] text-5xl sm:text-7xl md:text-8xl lg:text-[7.5rem] my-1">
              Our Fight.
            </span>
            <span className="block text-white text-5xl sm:text-7xl md:text-8xl lg:text-[7.5rem]">
              Your Payout.
            </span>
          </h1>

          <div className="mt-7 h-[3px] w-16 bg-[#E11D26]" />

          <p className="mt-6 text-white/85 text-base sm:text-lg max-w-2xl leading-relaxed">
            Your insurer has a team of adjusters protecting their profits. Now
            you have us. We fight relentlessly to get Tampa Bay homeowners every
            dollar they're owed — and we don't take a cent until you do.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-3">
            <a
              href="#contact"
              className="group inline-flex items-center justify-between gap-6 bg-[#E11D26] hover:bg-[#c11820] text-white font-bold uppercase tracking-wider px-7 py-4 transition-colors"
            >
              <span className="text-sm underline underline-offset-4">
                Get a Free Claim Review
              </span>
              <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="#how-it-works"
              className="group inline-flex items-center justify-between gap-6 bg-white hover:bg-white/90 text-black font-bold uppercase tracking-wider px-7 py-4 transition-colors"
            >
              <span className="text-sm underline underline-offset-4">
                How It Works
              </span>
              <ArrowDown className="h-5 w-5 transition-transform group-hover:translate-y-1" />
            </a>
          </div>
        </div>
      </div>

      {/* Stats bar */}
      <div className="relative border-t border-white/10 bg-black/70 backdrop-blur-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-white/10">
          {stats.map((s, i) => (
            <div
              key={i}
              className="py-7 sm:py-9 text-center flex flex-col items-center"
            >
              <div
                className="text-3xl sm:text-4xl md:text-5xl font-black text-[#E11D26]"
                style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
              >
                {s.value}
              </div>
              <div className="mt-2 text-white/80 text-xs sm:text-sm font-bold tracking-[0.3em]">
                {s.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
